module.exports = __webpack_public_path__ + "static/media/kiwi-bird.f23c39ee.svg";